var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobilepay = function SvgMobilepay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 41 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mobilepay_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 24,
    fill: "#5A78FF",
    rx: 3.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20.788 14.34q2.016-.615 3.411-.618 2.307-.006 3.868.916V10.17q-1.569-.812-3.546-.867a7.9 7.9 0 0 0-3.733.805z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m18.604 9.476 1.659 3.948V9.64a8.1 8.1 0 0 1 2.776-.9q1.464-.197 3.33.064l-.903-2.156a8.06 8.06 0 0 0-3.735.632 9.2 9.2 0 0 0-3.127 2.196",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.886 6.678-.654-1.586a1.45 1.45 0 0 0-1.887-.792l-4.51 1.859a1.45 1.45 0 0 0-.782 1.892l4.35 10.551a1.45 1.45 0 0 0 1.887.793l4.51-1.86a1.45 1.45 0 0 0 .781-1.892l-.54-1.308a18 18 0 0 0-.538-.026q-.18-.004-.513-.001l.701 1.702a.483.483 0 0 1-.26.63l-4.51 1.86a.48.48 0 0 1-.63-.265l-4.348-10.55a.483.483 0 0 1 .26-.631l4.51-1.86a.483.483 0 0 1 .63.265l.66 1.602q.306-.149.47-.215z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mobilepay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h41v24H0z"
  })))));
};
export default SvgMobilepay;